import { SR_API_ACTION_PARTNER_GET_OVERVIEW_STATS } from 'api/actionTypes';

export default async function getOverviewStats(
  { state, apiClient },
  { partnerId, startDate, endDate },
) {
  const stateRoute = ['partners', 'overviewStats', partnerId];

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_OVERVIEW_STATS,
    state: state,
    payload: {
      partnerId,
      startDate,
      endDate,
    },
    onSuccess(partnerOverviewStats) {
      state.set(stateRoute, partnerOverviewStats);
    },
  });
}
